import React from 'react';

const ActionButtons = ({
	backButtonDisabled,
	nextButtonDisabled,
	onBackClick,
	onNextClick,
	step,
}) => (
	<div className="np__actions">
		<button
			className="np__btn-back"
			disabled={backButtonDisabled}
			onClick={onBackClick}
			type="button"
		>
			Back
		</button>
		<button
			className="np__btn-next"
			disabled={nextButtonDisabled}
			onClick={onNextClick}
			type="button"
		>
			{step === 2 ? 'Create project' : 'Next'}
		</button>
	</div>
);

export default ActionButtons;
